import api from './api';

const usuarioService = {
  listar: async () => {
    const { data } = await api.get('/usuarios');
    return data.data;
  },

  crear: async (usuario) => {
    const { data } = await api.post('/usuarios', usuario);
    return data.data;
  },

  actualizar: async (id, usuario) => {
    const { data } = await api.put(`/usuarios/${id}`, usuario);
    return data.data;
  },

  eliminar: async (id) => {
    await api.delete(`/usuarios/${id}`);
  },
};

export default usuarioService;